import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent, PhoneNumberValidator } from './app.component';
import { HeaderComponent } from './__inc/header/header.component';
import { FooterComponent } from './__inc/footer/footer.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { BnNgIdleService } from 'bn-ng-idle'; // import bn-ng-idle service for session
import { RecaptchaModule } from 'ng-recaptcha';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import {
	DatePipe,
	HashLocationStrategy,
	LocationStrategy,
} from '@angular/common';
import { FaqComponent } from './webpages/faq/faq.component';
// import { CarouselModule } from 'ngx-owl-carousel-o';

import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SatNativeDateModule, SatDatepickerModule } from 'saturn-datepicker';

import {
	MatMomentDateModule,
	MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';

import { ContactusComponent } from './webpages/contactus/contactus.component';
import { HomeComponent } from './webpages/home/home.component';
import { NgxPrintModule } from 'ngx-print';
import { AboutusComponent } from './webpages/aboutus/aboutus.component';
// import { FileUploadModule } from 'ng2-file-upload';
import { ChartsModule } from 'ng2-charts';

import { Daterangepicker } from 'ng2-daterangepicker';
import { ScrolltotopComponent } from './__inc/scrolltotop/scrolltotop.component';
import { LoginComponent } from './auth/login/login.component';
import { LogoutComponent } from './auth/logout/logout.component';

import { OutboundregistrationComponent } from './passengerregistration/outboundregistration/outboundregistration.component';
// import { IvyCarouselModule } from 'angular-responsive-carousel';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { ResetpasswordComponent } from './auth/resetpassword/resetpassword.component';
import { WhatsupchatComponent } from './__inc/whatsupchat/whatsupchat.component';
import { TestComponent } from './admin/test/test.component';
import { InboundregistrationComponent } from './passengerregistration/Inboundregistration/Inboundregistration.component';
import { ReportComponent } from './admin/report/report.component';
import { LabSidebarComponent } from './__inc/lab-sidebar/lab-sidebar.component';
import { SamplecenterSidebarComponent } from './__inc/samplecenter-sidebar/samplecenter-sidebar.component';
import { LabusersComponent } from './laboratory/labusers/labusers.component';
import { SamplecollectioncentersComponent } from './laboratory/samplecollectioncenters/samplecollectioncenters.component';
import { LabdashboardComponent } from './dashboard/labdashboard/labdashboard.component';
import { SampleCenterDashboardComponent } from './dashboard/sample-center-dashboard/sample-center-dashboard.component';
import { LocatestoreComponent } from './webpages/locatestore/locatestore.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { SampleCenterAppointmentsComponent } from './samplecollection/sample-center-appointments/sample-center-appointments.component';
import { SampleCenterLoggedSamplesComponent } from './samplecollection/sample-center-logged-samples/sample-center-logged-samples.component';
import { SampleCenterResultsComponent } from './samplecollection/sample-center-results/sample-center-results.component';
import { SampleCenterCalendarComponent } from './samplecollection/sample-center-calendar/sample-center-calendar.component';
import { FooterDashboardComponent } from './__inc/footer-dashboard/footer-dashboard.component';
import { UseractivitiesComponent } from './laboratory/useractivities/useractivities.component';
import { AdduserComponent } from './laboratory/adduser/adduser.component';
import { EmployeesComponent } from './laboratory/employees/employees.component';
import { SampleCenterResultComponent } from './samplecollection/sample-center-result/sample-center-result.component';
import { LoggedsamplesComponent } from './laboratory/loggedsamples/loggedsamples.component';
import { ResultsComponent } from './laboratory/results/results.component';
import { SidebarComponent } from './__inc/sidebar/sidebar.component';
import { SampleCenterUsersComponent } from './samplecollection/sample-center-users/sample-center-users.component';
import { SampleCenterUsersActivitiesComponent } from './samplecollection/sample-center-users-activities/sample-center-users-activities.component';
import { SampleCenterAddUserComponent } from './samplecollection/sample-center-add-user/sample-center-add-user.component';
import { SampleCentersComponent } from './samplecollection/sample-centers/sample-centers.component';
import { SampleCenterEmployeesComponent } from './samplecollection/sample-center-employees/sample-center-employees.component';
import { ChangepasswordComponent } from './auth/changepassword/changepassword.component';
import { NavbarComponent } from './__inc/navbar/navbar.component';
import { MyprofileComponent } from './auth/myprofile/myprofile.component';
import { AgePipe } from './pipes/age.pipe';
import { UpdaterecordComponent } from './webpages/updaterecord/updaterecord.component';
import { TrackresultComponent } from './webpages/trackresult/trackresult.component';
import { MinistryDashboardComponent } from './dashboard/ministry-dashboard/ministry-dashboard.component';
import { AirportDashboardComponent } from './dashboard/airport-dashboard/airport-dashboard.component';
import { AirportSidebarComponent } from './__inc/airport-sidebar/airport-sidebar.component';
import { MinistrySidebarComponent } from './__inc/ministry-sidebar/ministry-sidebar.component';
import { RegisteredpassengersComponent } from './ministry/registeredpassengers/registeredpassengers.component';
import { TotalresultsComponent } from './ministry/totalresults/totalresults.component';
import { DefaultersComponent } from './ministry/defaulters/defaulters.component';
import { ForgedresultsComponent } from './ministry/forgedresults/forgedresults.component';
import { MedicallabsComponent } from './ministry/medicallabs/medicallabs.component';
import { MinistryofhealthusersComponent } from './ministry/ministryofhealthusers/ministryofhealthusers.component';
import { AirportpersonnelsComponent } from './ministry/airportpersonnels/airportpersonnels.component';
import { MakepaymentComponent } from './webpages/makepayment/makepayment.component';
import { AirportforgedresultsComponent } from './airport/airportforgedresults/airportforgedresults.component';
import { VerifyqrcodeComponent } from './airport/verifyqrcode/verifyqrcode.component';
import { VerifyuniqueidComponent } from './airport/verifyuniqueid/verifyuniqueid.component';
import { PaymentstatuspageComponent } from './passengerregistration/paymentstatuspage/paymentstatuspage.component';
import { VaccinationpassportComponent } from './webpages/vaccinationpassport/vaccinationpassport.component';
import { VaccinationpassportsComponent } from './ministry/vaccinationpassport/vaccinationpassport.component';

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		FooterComponent,
		PagenotfoundComponent,
		FaqComponent,
		ContactusComponent,
		HomeComponent,
		AboutusComponent,
		ScrolltotopComponent,
		LoginComponent,
		LogoutComponent,
		LabusersComponent,
		VerifyqrcodeComponent,
		VerifyuniqueidComponent,
		AirportforgedresultsComponent,
		SamplecollectioncentersComponent,
		OutboundregistrationComponent,
		InboundregistrationComponent,
		ForgotComponent,
		ResetpasswordComponent,
		WhatsupchatComponent,
		TestComponent,
		ReportComponent,
		LabSidebarComponent,
		AdduserComponent,
		UseractivitiesComponent,
		EmployeesComponent,
		SamplecenterSidebarComponent,
		LabdashboardComponent,
		SampleCenterDashboardComponent,
		LocatestoreComponent,
		SampleCenterAppointmentsComponent,
		SampleCenterLoggedSamplesComponent,
		SampleCenterResultsComponent,
		SampleCenterCalendarComponent,
		FooterDashboardComponent,
		SampleCenterResultComponent,
		LoggedsamplesComponent,
		ResultsComponent,
		SidebarComponent,
		SampleCenterUsersComponent,
		SampleCenterUsersActivitiesComponent,
		SampleCenterAddUserComponent,
		SampleCentersComponent,
		SampleCenterEmployeesComponent,
		ChangepasswordComponent,
		NavbarComponent,
		MyprofileComponent,
		AgePipe,
		UpdaterecordComponent,
		TrackresultComponent,
		MinistryDashboardComponent,
		AirportDashboardComponent,
		AirportSidebarComponent,
		MinistrySidebarComponent,
		RegisteredpassengersComponent,
		TotalresultsComponent,
		DefaultersComponent,
		ForgedresultsComponent,
		MedicallabsComponent,
		MinistryofhealthusersComponent,
		AirportpersonnelsComponent,
		MakepaymentComponent,
		PaymentstatuspageComponent,
		VaccinationpassportComponent,
		VaccinationpassportsComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		NgxPaginationModule,
		// IvyCarouselModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		RecaptchaModule,
		FlashMessagesModule.forRoot(),
		Ng4LoadingSpinnerModule.forRoot(),
		NgbModule,
		DataTablesModule,
		SweetAlert2Module.forRoot(),

		MatDatepickerModule,
		MatNativeDateModule,
		BrowserAnimationsModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		SatNativeDateModule,
		SatDatepickerModule,
		MatMomentDateModule,
		NgxPrintModule,
		ChartsModule,
		Daterangepicker,
		// CarouselModule,
		GoogleMapsModule,
	],
	// tslint:disable-next-line: max-line-length
	providers: [
		BnNgIdleService,
		DatePipe,
		AppComponent,
		Title,
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
	],

	bootstrap: [AppComponent],
})
export class AppModule {}
